import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-task-v2-show-more',
    templateUrl: './task-v2-show-more.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-show-more' },
    standalone: false,
})
export class TaskV2ShowMoreComponent {
    @Input() showAll = false;
    @Input() count = 0;

    @Output() toggleShowAll = new EventEmitter<void>();

    protected toggleShow(): void {
        this.toggleShowAll.emit();
    }
}
